import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'greaterThan',
    standalone: false
})
export class GreaterThanPipe implements PipeTransform {
    public transform(a: number, b: number, orEqualTo: boolean = false): boolean {
        return !orEqualTo ? a > b : a >= b;
    }
}
